import { render } from "./ArchiveHeaderTabs.vue?vue&type=template&id=d0afbdae&scoped=true"
import script from "./ArchiveHeaderTabs.vue?vue&type=script&lang=js"
export * from "./ArchiveHeaderTabs.vue?vue&type=script&lang=js"

import "./ArchiveHeaderTabs.vue?vue&type=style&index=0&id=d0afbdae&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0afbdae"]])

export default __exports__